import React, { PropsWithChildren, useState, useEffect } from 'react';
import {
    CurrencyFormat,
    NumberFormat,
    TimeFormat,
} from '@instinet-analytics/core-lib';
import { useSelectCurrentCurrency } from 'app/store/selectors';
import { Currency } from 'app/currencies/store/CurrencyState';
import Services from 'store/Services';
import { WidgetsService } from 'widgets/WidgetsService';
import { PortfolioService } from 'portfolio/PortfolioService';
import { SymbolsService } from 'symbols/SymbolsService';

export interface IndigoAppContextType {
    numberFormat: NumberFormat;
    currencyFormat: CurrencyFormat;
    timeFormat: TimeFormat;
    services: Services;
}

const numberFormat = new NumberFormat('en-US');
const timeFormat = new TimeFormat();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const emptySymbolsService = new SymbolsService({} as unknown as any);
const emptyWidgetsService = new WidgetsService({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    widgets: {} as unknown as any,
    symbolsService: emptySymbolsService,
});
const emptyPortfolioService = new PortfolioService({
    widgetsService: emptyWidgetsService,
});
const emptyService: Partial<Services> = {
    widgetsService: emptyWidgetsService,
    portfolioService: emptyPortfolioService,
};

const AppContext = React.createContext<IndigoAppContextType>(buildAppContext());

export type AppContextProviderProps = PropsWithChildren<{
    services: Services;
}>;

export function AppContextProvider(props: AppContextProviderProps) {
    const currency = useSelectCurrentCurrency();

    const [value, setValue] = useState<IndigoAppContextType>(
        buildAppContext(currency, props.services)
    );
    useEffect(() => {
        setValue(buildAppContext(currency, props.services));
    }, [currency, props.services]);

    return (
        <AppContext.Provider value={value}>
            {props.children}
        </AppContext.Provider>
    );
}

function buildAppContext(
    currency?: Currency,
    services?: Services
): IndigoAppContextType {
    return {
        numberFormat,
        currencyFormat: new CurrencyFormat(numberFormat, currency),
        timeFormat,
        services: services || (emptyService as Services),
    };
}

export default AppContext;
